import React from "react";
import CheckCircleSmall from "icons/CheckCircleSmall";
import EmptyCircleIcon from "icons/EmptyCircleIcon";

export default function DoneToggle({
  itemDone,
  setItemDone,
  handleDoneChange,
}) {
  function handleDoneToggleClick() {
    setItemDone(!itemDone);
    handleDoneChange && handleDoneChange(!itemDone);
  }

  function contents() {
    if (itemDone) {
      return <CheckCircleSmall onClick={handleDoneToggleClick} />;
    } else {
      return <EmptyCircleIcon onClick={handleDoneToggleClick} />;
    }
  }

  const doneString = itemDone ? "complete" : "incomplete";

  return (
    <div
      className="Done-toggle flex-center-div"
      data-cy={`toggle-${doneString}`}
    >
      {contents()}
    </div>
  );
}
